export default "__VITE_ASSET__DkGC7Ztn__"